import client from './client';
import { getRequestData } from './index';

export default (cid: string) => {

    console.error('Failed to Fetch Context');
    client.info('failed context load', {
        cid,
        context: 'ContextFetchErrorPage',
        ...getRequestData(),
    });
};
